import Home from "./Home";
import Surgalt from "./Surgalt";
import Erdem from "./Erdem";
import Other from "./Other";
import Teacher from "./Teacher";
import AdviceTeacher from "./AdviceTeacher"
import AddMenu from "./AddMenu";
import CreditVolume from './TimeEstimate'
// import Approve from "./Approve";
import Irts from "./Irts";
import Survey from "./Survey";
import HumanResource from "./HumanResource";

export default [
	...Home,
	...Teacher,
	...AdviceTeacher,
	...Irts,
	// ...HumanResource,
	...Survey,
	...AddMenu,
	...Surgalt,
	...CreditVolume,
	...Erdem,
	// ...Other,
];
